import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'

import Button from '../../components/Button'
import { useMediaQueries } from '../../hooks/useMediaQueries'
import {
  NoJobTitleFoundTitle,
  NoJobtitleInfoBox,
  NoJobTitleFoundBox,
  NoJobTitleFoundDescription,
  NoJobTitleFoundContainer,
} from './styles'
import NoJobTitleFoundIcon from './assets/NoJobTitleFoundIcon.svg'
import { TRANSLATION } from './utils'

const flexStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
} as const

export const NoJobTitleFound = () => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const KEY = `${TRANSLATION}.recommended.no_job_title`

  useEffect(() => {
    trackInternalEvent('recommended_courses_missing_title')
  }, [])

  return (
    <NoJobTitleFoundContainer data-testid="no-job-title-found">
      <NoJobTitleFoundBox hidden={isPhone} />
      <NoJobTitleFoundBox hidden={isPhone} />
      <NoJobTitleFoundBox />
      <NoJobTitleFoundBox />
      <NoJobtitleInfoBox>
        <img src={NoJobTitleFoundIcon} />
        <div style={flexStyles}>
          <NoJobTitleFoundTitle>{i18n.t(`${KEY}.title`)}</NoJobTitleFoundTitle>
          <NoJobTitleFoundDescription>{i18n.t(`${KEY}.description`)}</NoJobTitleFoundDescription>
        </div>
        <Button
          as={Link}
          to="/career-profile/edit?section=jobPreferences&returnUrl=/?categoryTab=learning&serviceId=upskill"
          onClick={() => trackInternalEvent('recommended_courses_add_title')}
          data-testid="add-job-title-button"
        >
          {i18n.t(`${KEY}.button`)}
        </Button>
      </NoJobtitleInfoBox>
    </NoJobTitleFoundContainer>
  )
}

export const InvalidJobTitleForRecommendedQuery = (props: { jobTitle: string }) => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const KEY = `${TRANSLATION}.recommended.invalid_job_title`

  useEffect(() => {
    trackInternalEvent('recommended_courses_missing_title')
  }, [])

  return (
    <NoJobTitleFoundContainer data-testid="no-job-title-found">
      <NoJobTitleFoundBox hidden={isPhone} />
      <NoJobTitleFoundBox hidden={isPhone} />
      <NoJobTitleFoundBox />
      <NoJobTitleFoundBox />
      <NoJobtitleInfoBox>
        <img src={NoJobTitleFoundIcon} />
        <div style={flexStyles}>
          <NoJobTitleFoundTitle>
            {i18n.t(`${KEY}.title`, { job_title: props.jobTitle })}
          </NoJobTitleFoundTitle>
          <NoJobTitleFoundDescription>{i18n.t(`${KEY}.description`)}</NoJobTitleFoundDescription>
        </div>
        <Button
          as={Link}
          to="/career-profile/edit?section=jobPreferences&returnUrl=/?categoryTab=learning&serviceId=upskill"
          onClick={() => trackInternalEvent('recommended_courses_add_title')}
          data-testid="add-job-title-button"
        >
          {i18n.t(`${KEY}.button`)}
        </Button>
      </NoJobtitleInfoBox>
    </NoJobTitleFoundContainer>
  )
}
